import React from 'react';
import { withLocalize, Translate } from 'react-localize-redux';
import { isNullOrUndefined } from '../../../../store/storeFunctions';

import '../../repi.scss';

class RequestingHistory extends React.Component {
    state = { page: 1 };

    render() {
        const { data } = this.props;
        if (isNullOrUndefined(data) || isNullOrUndefined(data.requestsPast30Days) || data.requestsPast30Days < 0)
            return null;

        return (
            <div className="repi-requesting-history bold repi-payment-history-1em-wrapper">
                <div><Translate id="Repi.Report.RequestingHistory.Title" />:</div>&nbsp;
                <div className="repi-requesting-history-amount">{data.requestsPast30Days}</div>
            </div>
        );
    }
}

export default withLocalize(RequestingHistory);
